import { map, Observable, of, tap } from 'rxjs';
import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { first } from 'rxjs/operators';

const emptyFn = () => {
    // NOOP
};

export const remoteValueExistsValidator = (checkRemoteValue: (value: string) => Observable<boolean>,
    invalidWhen = true,
    beforeAction: () => void = emptyFn,
    afterAction: () => void = emptyFn,
    initialValue = ''
): AsyncValidatorFn =>
    (control: AbstractControl): Promise<ValidationErrors | null> |
        Observable<ValidationErrors | null> => {
        if (!control.dirty || !control.value || !control.value?.length || initialValue === control.value) {
            return of(null);
        }
        return checkRemoteValue(control.value).pipe(
            tap(beforeAction),
            map(response => (response === invalidWhen ? { existingValue: true } : null)),
            tap(afterAction),
            first()
        );
    };
